module.exports = __webpack_public_path__ + "static/media/icon_faq_add.6048f614.svg";